import { render } from "./DisputeModal.vue?vue&type=template&id=08cb8a6c&scoped=true"
import script from "./DisputeModal.vue?vue&type=script&lang=js"
export * from "./DisputeModal.vue?vue&type=script&lang=js"

import "./DisputeModal.vue?vue&type=style&index=0&id=08cb8a6c&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cb8a6c"]])

export default __exports__